// extracted by mini-css-extract-plugin
export default {"badges":"ClientPage_badges__dyvI-","licenseLogo":"ClientPage_licenseLogo__BRAeq","ageLogo":"ClientPage_ageLogo__rnO56"};